<template>
  <div class="container mt-0">
    <div class="row">
      <div class="col-12 px-0">
        <label for="name" class="font-weight-light small text-muted">Company Legal Name {{ setOrg }}<span class="text-danger">*</span></label>
        <input type="text" class="form-control" v-model="org.company" placeholder="Company Name" />
      </div>
    </div>
    <!-- <hr class="mt-1 px-0 mx-0" /> -->
    <div class="row" v-if="(product == 1 && $route.fullPath == '/dashboard') || (sofwareFilterProduct != 1)" >
      <div class="col-12 px-0">
        <h5 class="text-dark font-weight-bold">Address</h5>
        <div class="form-group">
          <label for="address" class="font-weight-light small text-muted">
            Address<span
                class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="org.address" placeholder="Address" value="" />
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="address" class="font-weight-light small text-muted">
                City<span
                class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="org.city" placeholder="City" value="" />
            </div>
            <div class="form-group">
              <label for="address" class="font-weight-light small text-muted">
                Country
              <span
                class="text-danger">*</span></label>
              <multiselect v-model="org.country" :options="countries" :multiple="false" :internal-search="true"
              :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :allow-empty="true"></multiselect>
            </div>
            <div class="form-group">
              <label for="address" class="font-weight-light small text-muted">
                Phone<span
                class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="org.phone" placeholder="Phone" value="" />
            </div>
            <div class="form-group">
              <label for="address" class="font-weight-light small text-muted">
                Customer Interest<span class="text-danger">*</span></label>
              <multiselect v-model="org.customer_interest" :options="customer_interest" :multiple="false" :internal-search="true"
              :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :allow-empty="true"></multiselect>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="state" class="font-weight-light small text-muted">
                State<span
                class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="org.state" placeholder="State" value="" />
            </div>
            <div class="form-group">
              <label for="zip_code" class="font-weight-light small text-muted">
                Zip Code<span
                class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="org.zipcode" placeholder="Zip Code" value="" />
            </div>
            <div class="form-group">
              <label for="address" class="font-weight-light small text-muted">
                Website<span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="org.website" placeholder="Website" value="" />
            </div>
            <div class="form-group">
              <label for="fax" class="font-weight-light small text-muted">
                Fax</label>
              <input type="text" v-model="org.fax" class="form-control" placeholder="Fax" value="" />
            </div>
          </div>
        </div>
        <div class="form-group">
              <label for="customer_interest" class="font-weight-light small text-muted">
               Timezone<span class="text-danger">*</span></label>
               <multiselect v-model="org.time_zone" :options="timezone_options" :multiple="false" :internal-search="true"
              :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :allow-empty="true" label="name" track-by="value"></multiselect>

            </div>


      </div>
    </div>
    <!-- <hr class="mt-1 px-0" />  -->
    <div class="row" >
      <div class="col-12 px-0">
        <div class="d-flex justify-content-between">
          <h5 class="text-dark font-weight-bold">Contact Person</h5>
        <p @click="addContactEmail" style="cursor: pointer; color: #48a6a6;">Add More Email</p>
        </div>

        <div class="form-group" v-if="(product == 1)">
          <label for="address" class="font-weight-light small text-muted">Name<span
                class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="org.name" placeholder="Name" value="" />
        </div>
        <div class="row" >
          <div class="col-6" v-if="(product == 1)">
            <label for="address" class="font-weight-light small text-muted">Designation <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="org.designation" placeholder="Designation" value="" />
          </div>
          <div class="col-6">
            <label for="address" class="font-weight-light small text-muted">Email Address<span
                class="text-danger">*</span></label>
            <input type="text" v-model="org.user_email" class="form-control" placeholder="Email Address" value="" />
          </div>
          <div v-for="(input, index) in additional_emails" :key="index" class="col-6">
            <label :for="'address' + index" class="font-weight-light small text-muted">
              Email Address {{ index + 1 }}
            </label>
            <input
                type="email"
                v-model="org.contact_emails[index]"
                :id="'address' + index"
                class="form-control"
                placeholder="Email Address"
            />
          </div>

        </div>
      </div>
    </div>
    <!-- <hr class="mt-1" /> -->
    <div class="row">
      <div class="col-12 px-0">
        <h5 class="text-dark font-weight-bold">Login Information</h5>
        <div class="form-group mt-4">
          <label for="address" class="font-weight-light small text-muted">Username<span
                class="text-danger">*</span></label>
          <input type="text" v-model="org.user_name" class="form-control" placeholder="Username " value="" />
        </div>
        <div class="form-group mt-4">
          <label for="password" class="font-weight-light small text-muted">Password<span class="text-danger">*</span></label>
          <input type="password" v-model="org.password" class="form-control" placeholder="password " value="" />
        </div>
      </div>
    </div>
    <!-- <hr class="bg-muted" /> -->
    <div class="float-right ml-auto mt-1">
      <button type="button" class="btn btn-secondary px-3 py-2" data-dismiss="modal">
        Cancel
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default text-light ml-3 px-3 py-2" @click="save">
      <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>
    </div>
  </div>
</template>
<script>
  import Multiselect from "vue-multiselect";
  import axios from "axios";
  import { mapState } from 'vuex';
  import {isEmpty} from "lodash/lang";
  export default {
     components: {
          Multiselect
        },
    data: function () {
      return {
        additional_emails:[],
        selected_software_filter: 'all',
        product: 0,
        countries: [],
        isMiniLoading : false,
        selected: "",
        org: this.get_empty_org_obj(),
        customer_interest: [
          "Very Slow",
          "Motivated",
          "Hyper"
        ],
        time_zone:"",
        timezone_options:[
                { value:"Pacific/Midway",  name :"(UTC-11:00) Midway Island" },
                { value:"Pacific/Samoa",  name :"(UTC-11:00) Samoa" },
                { value:"Pacific/Honolulu",  name :"(UTC-10:00) Hawaii" },
                { value:"US/Alaska",  name :"(UTC-09:00) Alaska" },
                { value:"America/Los_Angeles",  name :"(UTC-08:00) Pacific Time (US & Canada)" },
                { value:"America/Tijuana",  name :"(UTC-08:00) Tijuana" },
                { value:"US/Arizona",  name :"(UTC-07:00) Arizona" },
                { value:"America/Chihuahua",  name :"(UTC-07:00) Chihuahua" },
                { value:"America/Chihuahua",  name :"(UTC-07:00) La Paz" },
                { value:"America/Mazatlan",  name :"(UTC-07:00) Mazatlan" },
                { value:"US/Mountain",  name :"(UTC-07:00) Mountain Time (US & Canada)" },
                { value:"America/Managua",  name :"(UTC-06:00) Central America" },
                { value:"US/Central",  name :"(UTC-06:00) Central Time (US & Canada)" },
                { value:"America/Mexico_City",  name :"(UTC-06:00) Guadalajara" },
                { value:"America/Mexico_City",  name :"(UTC-06:00) Mexico City" },
                { value:"America/Monterrey",  name :"(UTC-06:00) Monterrey" },
                { value:"Canada/Saskatchewan",  name :"(UTC-06:00) Saskatchewan" },
                { value:"America/Bogota",  name :"(UTC-05:00) Bogota" },
                { value:"US/Eastern",  name :"(UTC-05:00) Eastern Time (US & Canada)" },
                { value:"US/East-Indiana",  name :"(UTC-05:00) Indiana (East)" },
                { value:"America/Lima",  name :"(UTC-05:00) Lima" },
                { value:"America/Bogota",  name :"(UTC-05:00) Quito" },
                { value:"Canada/Atlantic",  name :"(UTC-04:00) Atlantic Time (Canada)" },
                { value:"America/Caracas",  name :"(UTC-04:30) Caracas" },
                { value:"America/La_Paz",  name :"(UTC-04:00) La Paz" },
                { value:"America/Santiago",  name :"(UTC-04:00) Santiago" },
                { value:"Canada/Newfoundland",  name :"(UTC-03:30) Newfoundland" },
                { value:"America/Sao_Paulo",  name :"(UTC-03:00) Brasilia" },
                { value:"America/Argentina/Buenos_Aires",  name :"(UTC-03:00) Buenos Aires" },
                { value:"America/Argentina/Buenos_Aires",  name :"(UTC-03:00) Georgetown" },
                { value:"America/Godthab",  name :"(UTC-03:00) Greenland" },
                { value:"America/Noronha",  name :"(UTC-02:00) Mid-Atlantic" },
                { value:"Atlantic/Azores",  name :"(UTC-01:00) Azores" },
                { value:"Atlantic/Cape_Verde",  name :"(UTC-01:00) Cape Verde Is." },
                { value:"Africa/Casablanca",  name :"(UTC+00:00) Casablanca" },
                { value:"Europe/London",  name :"(UTC+00:00) Edinburgh" },
                { value:"Etc/Greenwich",  name :"(UTC+00:00) Greenwich Mean Time : Dublin" },
                { value:"Europe/Lisbon",  name :"(UTC+00:00) Lisbon" },
                { value:"Europe/London",  name :"(UTC+00:00) London" },
                { value:"Africa/Monrovia",  name :"(UTC+00:00) Monrovia" },
                { value:"UTC",  name :"(UTC+00:00) UTC" },
                { value:"Europe/Amsterdam",  name :"(UTC+01:00) Amsterdam" },
                { value:"Europe/Belgrade",  name :"(UTC+01:00) Belgrade" },
                { value:"Europe/Berlin",  name :"(UTC+01:00) Berlin" },
                { value:"Europe/Berlin",  name :"(UTC+01:00) Bern" },
                { value:"Europe/Bratislava",  name :"(UTC+01:00) Bratislava" },
                { value:"Europe/Brussels",  name :"(UTC+01:00) Brussels" },
                { value:"Europe/Budapest",  name :"(UTC+01:00) Budapest" },
                { value:"Europe/Copenhagen",  name :"(UTC+01:00) Copenhagen" },
                { value:"Europe/Ljubljana",  name :"(UTC+01:00) Ljubljana" },
                { value:"Europe/Madrid",  name :"(UTC+01:00) Madrid" },
                { value:"Europe/Paris",  name :"(UTC+01:00) Paris" },
                { value:"Europe/Prague",  name :"(UTC+01:00) Prague" },
                { value:"Europe/Rome",  name :"(UTC+01:00) Rome" },
                { value:"Europe/Sarajevo",  name :"(UTC+01:00) Sarajevo" },
                { value:"Europe/Skopje",  name :"(UTC+01:00) Skopje" },
                { value:"Europe/Stockholm",  name :"(UTC+01:00) Stockholm" },
                { value:"Europe/Vienna",  name :"(UTC+01:00) Vienna" },
                { value:"Europe/Warsaw",  name :"(UTC+01:00) Warsaw" },
                { value:"Africa/Lagos",  name :"(UTC+01:00) West Central Africa" },
                { value:"Europe/Zagreb",  name :"(UTC+01:00) Zagreb" },
                { value:"Europe/Athens",  name :"(UTC+02:00) Athens" },
                { value:"Europe/Bucharest",  name :"(UTC+02:00) Bucharest" },
                { value:"Africa/Cairo",  name :"(UTC+02:00) Cairo" },
                { value:"Africa/Harare",  name :"(UTC+02:00) Harare" },
                { value:"Europe/Helsinki",  name :"(UTC+02:00) Helsinki" },
                { value:"Europe/Istanbul",  name :"(UTC+02:00) Istanbul" },
                { value:"Asia/Jerusalem",  name :"(UTC+02:00) Jerusalem" },
                { value:"Europe/Helsinki",  name :"(UTC+02:00) Kyiv" },
                { value:"Africa/Johannesburg",  name :"(UTC+02:00) Pretoria" },
                { value:"Europe/Riga",  name :"(UTC+02:00) Riga" },
                { value:"Europe/Sofia",  name :"(UTC+02:00) Sofia" },
                { value:"Europe/Tallinn",  name :"(UTC+02:00) Tallinn" },
                { value:"Europe/Vilnius",  name :"(UTC+02:00) Vilnius" },
                { value:"Asia/Baghdad",  name :"(UTC+03:00) Baghdad" },
                { value:"Asia/Kuwait",  name :"(UTC+03:00) Kuwait" },
                { value:"Europe/Minsk",  name :"(UTC+03:00) Minsk" },
                { value:"Africa/Nairobi",  name :"(UTC+03:00) Nairobi" },
                { value:"Asia/Riyadh",  name :"(UTC+03:00) Riyadh" },
                { value:"Europe/Volgograd",  name :"(UTC+03:00) Volgograd" },
                { value:"Asia/Tehran",  name :"(UTC+03:30) Tehran" },
                { value:"Asia/Muscat",  name :"(UTC+04:00) Abu Dhabi" },
                { value:"Asia/Baku",  name :"(UTC+04:00) Baku" },
                { value:"Europe/Moscow",  name :"(UTC+04:00) Moscow" },
                { value:"Asia/Muscat",  name :"(UTC+04:00) Muscat" },
                { value:"Europe/Moscow",  name :"(UTC+04:00) St. Petersburg" },
                { value:"Asia/Tbilisi",  name :"(UTC+04:00) Tbilisi" },
                { value:"Asia/Yerevan",  name :"(UTC+04:00) Yerevan" },
                { value:"Asia/Kabul",  name :"(UTC+04:30) Kabul" },
                { value:"Asia/Karachi",  name :"(UTC+05:00) Islamabad" },
                { value:"Asia/Karachi",  name :"(UTC+05:00) Karachi" },
                { value:"Asia/Tashkent",  name :"(UTC+05:00) Tashkent" },
                { value:"Asia/Calcutta",  name :"(UTC+05:30) Chennai" },
                { value:"Asia/Kolkata",  name :"(UTC+05:30) Kolkata" },
                { value:"Asia/Calcutta",  name :"(UTC+05:30) Mumbai" },
                { value:"Asia/Calcutta",  name :"(UTC+05:30) New Delhi" },
                { value:"Asia/Calcutta",  name :"(UTC+05:30) Sri Jayawardenepura" },
                { value:"Asia/Katmandu",  name :"(UTC+05:45) Kathmandu" },
                { value:"Asia/Almaty",  name :"(UTC+06:00) Almaty" },
                { value:"Asia/Dhaka",  name :"(UTC+06:00) Astana" },
                { value:"Asia/Dhaka",  name :"(UTC+06:00) Dhaka" },
                { value:"Asia/Yekaterinburg",  name :"(UTC+06:00) Ekaterinburg" },
                { value:"Asia/Rangoon",  name :"(UTC+06:30) Rangoon" },
                { value:"Asia/Bangkok",  name :"(UTC+07:00) Bangkok" },
                { value:"Asia/Bangkok",  name :"(UTC+07:00) Hanoi" },
                { value:"Asia/Jakarta",  name :"(UTC+07:00) Jakarta" },
                { value:"Asia/Novosibirsk",  name :"(UTC+07:00) Novosibirsk" },
                { value:"Asia/Hong_Kong",  name :"(UTC+08:00) Beijing" },
                { value:"Asia/Chongqing",  name :"(UTC+08:00) Chongqing" },
                { value:"Asia/Hong_Kong",  name :"(UTC+08:00) Hong Kong" },
                { value:"Asia/Krasnoyarsk",  name :"(UTC+08:00) Krasnoyarsk" },
                { value:"Asia/Kuala_Lumpur",  name :"(UTC+08:00) Kuala Lumpur" },
                { value:"Australia/Perth",  name :"(UTC+08:00) Perth" },
                { value:"Asia/Singapore",  name :"(UTC+08:00) Singapore" },
                { value:"Asia/Taipei",  name :"(UTC+08:00) Taipei" },
                { value:"Asia/Ulan_Bator",  name :"(UTC+08:00) Ulaan Bataar" },
                { value:"Asia/Urumqi",  name :"(UTC+08:00) Urumqi" },
                { value:"Asia/Irkutsk",  name :"(UTC+09:00) Irkutsk" },
                { value:"Asia/Tokyo",  name :"(UTC+09:00) Osaka" },
                { value:"Asia/Tokyo",  name :"(UTC+09:00) Sapporo" },
                { value:"Asia/Seoul",  name :"(UTC+09:00) Seoul" },
                { value:"Asia/Tokyo",  name :"(UTC+09:00) Tokyo" },
                { value:"Australia/Adelaide",  name :"(UTC+09:30) Adelaide" },
                { value:"Australia/Darwin",  name :"(UTC+09:30) Darwin" },
                { value:"Australia/Brisbane",  name :"(UTC+10:00) Brisbane" },
                { value:"Australia/Canberra",  name :"(UTC+10:00) Canberra" },
                { value:"Pacific/Guam",  name :"(UTC+10:00) Guam" },
                { value:"Australia/Hobart",  name :"(UTC+10:00) Hobart" },
                { value:"Australia/Melbourne",  name :"(UTC+10:00) Melbourne" },
                { value:"Pacific/Port_Moresby",  name :"(UTC+10:00) Port Moresby" },
                { value:"Australia/Sydney",  name :"(UTC+10:00) Sydney" },
                { value:"Asia/Yakutsk",  name :"(UTC+10:00) Yakutsk" },
                { value:"Asia/Vladivostok",  name :"(UTC+11:00) Vladivostok" },
                { value:"Pacific/Auckland",  name :"(UTC+12:00) Auckland" },
                { value:"Pacific/Fiji",  name :"(UTC+12:00) Fiji" },
                { value:"Pacific/Kwajalein",  name :"(UTC+12:00) International Date Line West" },
                { value:"Asia/Kamchatka",  name :"(UTC+12:00) Kamchatka" },
                { value:"Asia/Magadan",  name :"(UTC+12:00) Magadan" },
                { value:"Pacific/Fiji",  name :"(UTC+12:00) Marshall Is." },
                { value:"Asia/Magadan",  name :"(UTC+12:00) New Caledonia" },
                { value:"Asia/Magadan",  name :"(UTC+12:00) Solomon Is." },
                { value:"Pacific/Auckland",  name :"(UTC+12:00) Wellington" },
                { value:"Pacific/Tongatapu",  name :"(UTC+13:00) Nuku'alofa" },
        ]
      };
    },
    props: ["action", "formData"],
    computed: {

      selectedProduct: function () {
        return this.$store.getters["persist/selectedProduct"];
      },
      ...mapState('users', ['sofwareFilterProduct']),

      setOrg: function () {
        this.org.company = this.formData.company || '';
        this.org.phone = this.formData.phone || '';
        this.org.user_email = this.formData.email || '';
        this.org.website = this.formData.website || '';
        this.org.country = this.formData.country || '';
        this.org.name = this.formData.name || '';
        this.org.lead_status = this.formData.lead_status || '';
      },
    },
    created: function () {
      this.product = localStorage.getItem('product');
      this.org = this.get_empty_org_obj();
      const permission = {
        headers: {
          'X-Permission': 'lead_set_followup_date'
        }
      };
      axios.get('admin/users/countries', permission).then((response) => {
        this.countries = response.data.countries;
      });
    },
    mounted() {
      this.org = this.get_empty_org_obj();
    },

    methods: {
      addContactEmail(){
        this.additional_emails.push({
          value: ""
        });
      },
      save() {
        let org_name;
        var filtered_org_name;
        this.isMiniLoading = true;
        const permission = {
          headers: {
            'X-Permission': 'lead_create_organization'
          }
        };
        if (this.product == 2 || this.sofwareFilterProduct == 2) {

          if (
              this.org.user_name.replace(/\s/g, "").length &&
              this.org.company.replace(/\s/g, "").length &&
              this.org.password.replace(/\s/g, "").length &&
              this.org.user_email.replace(/\s/g, "").length
          ) {
            org_name = this.org.user_name;
            filtered_org_name = org_name.replace(/([^\w]+|\s+)/g, "");
            axios
                .post("/admin/users/create-organization", {
                  lead_id: this.formData.lead_id,
                  cname: this.org.company,
                  name: filtered_org_name,
                  email: this.org.user_email,
                  password: this.org.password,
                  product: this.product,
                  contact_emails: this.org.contact_emails,
                  sofwareFilterProduct: this.sofwareFilterProduct,
                  lead_status: this.org.lead_status

                }, permission)
                .then(() => {
                  // this.isMiniLoading = false;
                  window.$("#modal").modal("hide");
                  this.$toast.success("Organization Created Successfully!");
                  this.org = this.get_empty_org_obj();
                  // this.$router.push("on-boarding");
                })
                .catch(() => {
                  this.isMiniLoading = false;
                  if (response.status && response.status !== 200) {
                    this.$toast.error('Opps! Something Went Wrong', {});
                  }
                });
          } else {
            this.isMiniLoading = false;
            this.$toast.warning("Please Fill All Required Fields");
          }


        } else {
          if (
              this.org.user_name.replace(/\s/g, "").length &&
              this.org.company.replace(/\s/g, "").length &&
              this.org.address.replace(/\s/g, "").length &&
              this.org.designation.replace(/\s/g, "").length &&
              this.org.phone.replace(/\s/g, "").length &&
              !isEmpty(this.org.country) &&
              this.org.zipcode.replace(/\s/g, "").length &&
              this.org.password.replace(/\s/g, "").length &&
              this.org.user_email.replace(/\s/g, "").length &&
              !isEmpty(this.org.customer_interest) &&
              !isEmpty(this.org.time_zone) &&
              this.org.state != '' && this.org.city != '' && this.org.website != '' && this.org.name != ''
          ) {

            if (this.org.company) {
              const companyName = this.org.company.trim();
              if (this.containsOnlyNumbers(companyName)) {
                this.$toast.error('Please enter a valid company name');
                this.isMiniLoading = false;
                return false;
              }
            }

            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.org.user_email)) {
              this.$toast.error('Please enter a valid email address');
              this.isMiniLoading = false;
              return false;
            }

            // URL validation
            if (!/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.org.website)) {
              this.$toast.error('Please enter a valid Website');
              this.isMiniLoading = false;
              return false;
            }

            if (!/^[0-9]+$/.test(this.org.phone)) {
              this.$toast.error('Please enter a valid phone number');
              this.isMiniLoading = false;
              return false;
            }

            if (this.org.name) {
              if (this.containsOnlyNumbers(this.org.company.trim())) {
                this.$toast.error('Please enter a valid user name');
                this.isMiniLoading = false;
                return false;
              }
            }
            org_name = this.org.user_name;
            filtered_org_name = org_name.replace(/([^\w]+|\s+)/g, "");
            axios
                .post("/admin/users/create-organization", {
                  lead_id: this.formData.lead_id,
                  legal_name: this.org.company,
                  user_name: filtered_org_name,
                  website: this.org.website,
                  street_address: this.org.address,
                  country: this.org.country,
                  state: this.org.state,
                  city: this.org.city,
                  zipcode: this.org.zipcode,
                  phone: this.org.phone,
                  customer_interest: this.org.customer_interest,
                  fax: this.org.fax,
                  contact_name: this.org.name,
                  contact_designation: this.org.designation,
                  contact_email: this.org.user_email,
                  password: this.org.password,
                  product: this.product,
                  contact_emails: this.org.contact_emails,
                  time_zone: this.org.time_zone.value,
                }, permission)
                .then((response) => {
                  this.isMiniLoading = false;
                  if (response.data.error) {
                    this.$toast.error(response.data.error);
                  } else {
                    window.$("#modal").modal("hide");
                    this.$toast.success('Organization Created Successfully');
                    this.org = this.get_empty_org_obj();
                    this.$parent.getOrganizationRecord();
                  }
                })
                .catch((response) => {
                  this.isMiniLoading = false;
                  if (response.status && response.status !== 200) {
                    this.$toast.error('Opps! Something Went Wrong', {});
                  }
                });
          } else {
            this.isMiniLoading = false;
            this.$toast.warning("Please Fill All Required Fields");
          }


        }

      },
      get_empty_org_obj() {
        return {
          company: "",
          website: "",
          address: "",
          phone: "",
          fax: "",
          country: "",
          state: "",
          city: "",
          zipcode: "",
          name: "",
          designation: "",
          user_email: "",
          user_name: "",
          password: "",
          customer_interest: "",
          time_zone:"",
          contact_emails:[]
        };
      },
      containsOnlyNumbers(input) {
        return !isNaN(input);
      }
    },
  };
</script>
<style scoped>
.text-dark{
    color: rgb(72, 166, 166) !important;
}
.multiselect__single{
  margin-bottom: 5px !important;
}
.multiselect{
  min-height: 32px !important;
}
.multiselect .multiselect__tags {
    border-radius: 0.25rem;
    min-height: 32px !important;
  }
  .multiselect__single{
    margin-bottom:5px !important;
  }
</style>
